export const isSpreadSheetOrDocument = (fileURL) => {
  const fileExtension = fileURL.split("?")[0].split(".").pop();
  return ["docx", "doc", "xlsx", "xlx"].includes(fileExtension);
};
